module.exports = __webpack_public_path__ + "static/media/app_dev_consultant.c05370ef.png";